import { useEffect, useState } from "react";
import { formatDate } from "../../utils/formatDate/formatDate";
export const useArticleInfoDisplay = (creationDate = "", readTime = "") => {
    const [formattedCreationDate, setFormattedCreationDate] = useState(readTime);
    useEffect(() => {
        if (creationDate) {
            const text = `${formatDate(creationDate)}${readTime ? ` - ${readTime}` : ""}`;
            setFormattedCreationDate(text);
        }
    }, [creationDate, readTime]);
    return formattedCreationDate;
};
//# sourceMappingURL=useArticleInfoDisplay.js.map